import { render } from "./ConfirmMessages.vue?vue&type=template&id=2dd488ec"
import script from "./ConfirmMessages.vue?vue&type=script&lang=js"
export * from "./ConfirmMessages.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__